import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import useUser from "../../../hooks/user/useUser";
import { IUserData } from "../../../interfaces/user/IUserData";
import {
  BlogCardOptionsModal,
  useBlogCardOptionsContext,
} from "./blogCardModal";
import { AppIconButton } from "../../global/ui/buttons";
import { MoreVert } from "@mui/icons-material";

type BlogOptionsProps = { coach: IUserData };

export const BlogOptions = ({ coach }: BlogOptionsProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);
  const { user } = useUser();
  const { state, dispatch } = useBlogCardOptionsContext();

  const optionsHandler = () => {
    if (state.modal.length === 0) {
      dispatch({
        modal: [<BlogCardOptionsModal key={coach.id} coach={coach} />],
      });

      return;
    }

    dispatch({
      modal: [],
    });
  };

  if (user?.token) {
    return (
      <AppIconButton
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          optionsHandler();
        }}
      >
        <MoreVert
          sx={{
            color: colors.surface.onSurface,
          }}
        />
      </AppIconButton>
    );
  }
};
